/**
 * Client setup function for Wasp
 * Configures React Router future flags, React Query defaults, and initializes analytics
 */

import { initAnalytics } from "../analytics";
import { configureQueryClient } from "wasp/client/operations";

export const setupClient = (wasp) => {
  // Configure React Query defaults to reduce excessive refetching
  configureQueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        retry: 1,
        staleTime: 10 * 60 * 1000, // 10 minutes
        gcTime: 30 * 60 * 1000, // 30 minutes
      },
      mutations: {
        retry: 0,
      },
    },
  });

  // Configure React Router future flags
  if (wasp && wasp.router && wasp.router.setFutureFlags) {
    wasp.router.setFutureFlags({
      v7_startTransition: true,
    });
  }

  // Initialize analytics system
  initAnalytics().catch(console.error);

  console.log(
    "Client setup completed with React Router v7 future flags, React Query defaults, and analytics",
  );
};
